<template>
  <div id="simple-calendar-app">
    <div class=" no-scroll-content">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="simpleCalendarEvents"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewEvent"
        @click-event="openEditEvent"
        @drop-on-date="eventDragged">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <!-- Add new event button -->
            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                  <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                      <span>{{ label.text }}</span>
                  </div>
                  <!--div class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                      <span>None</span>
                  </div-->
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

    <!-- ADD EVENT -->
    

    <!-- EDIT EVENT -->
    <vs-prompt
        class="calendar-event-dialog"
        title="Edit Seance"
        button-cancel = "border"
        
        :is-valid="validForm"
        :active.sync="activePromptEditEvent">

        <!--div class="calendar__label-container flex">

            <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>

            <vs-dropdown vs-custom-content class="ml-auto my-2 cursor-pointer">

                <feather-icon icon="TagIcon" svgClasses="h-5 w-5" @click.prevent></feather-icon>

                <vs-dropdown-menu style="z-index: 200001">
                        <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                            <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                            <span>{{ label.text }}</span>
                        </vs-dropdown-item>

                        <vs-dropdown-item @click="labelLocal = 'none'">
                            <div class="h-3 w-3 mr-1 inline-block rounded-full mr-2 bg-primary"></div>
                            <span>None</span>
                        </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

        </div-->

        <!-- Groupe-->
        <div class="mt-5">
          <label class="text-sm opacity-75">Groupe</label>
          <v-select disabled  :options="groupe_choices" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="groupe_data" class="mb-4 md:mb-0" v-validate="'required'"/>
        </div>
        <small class="date-label">Start Date</small>
        <div class="mb-4">
        <flat-pickr disabled  :config="configdatePicker" v-model="startDate" placeholder="Choose Date" />
        </div>
        <small class="date-label">Time</small>
        <div >
            
            <flat-pickr disabled  :config="configdateTimePicker" v-model="time_data" placeholder="Choose time" v-validate="'required'"/>
        </div>
    </vs-prompt>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {French as FrenchLocale} from 'flatpickr/dist/l10n/fr.js';

import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
import moduleseance from '@/store/seance/moduleseance.js'
import moduleclasse from '@/store/classe/moduleclasse.js'
import moduledomaine from '@/store/domaine/moduledomaine.js'
require("vue-simple-calendar/static/css/default.css")

import Datepicker from 'vuejs-datepicker'
import { en, he } from "vuejs-datepicker/src/locale"
import vSelect from 'vue-select'
export default {
  components: {
    flatPickr,
    vSelect,
    CalendarView,
    CalendarViewHeader,
    Datepicker
  },
  data() {
    return {
      time_data: null,
            configdateTimePicker: {
              enableTime: true,
              enableSeconds: true,
              noCalendar: true
            },
      configdatePicker: {
              locale: FrenchLocale
            },
      groupe_data: null,
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',

      langHe: he,
      langEn: en,

      url: '',
      calendarView: 'month',

      activePromptAddEvent: false,
      activePromptEditEvent: false,

      calendarViewTypes: [
        {
          label: "Month",
          val: "month"
        },
        {
          label: "Week",
          val: "week"
        },
        {
          label: "Year",
          val: "year"
        },
        
      ]
    }
  },
  computed: {
    groupe_choices() {
        let opts=[];
          
              opts.push({label:this.$store.state.classe.seances[0].titre+' '+'Groupe'+' '+this.$store.state.classe.seances[0].numero, value: this.$route.params.userId});
              
            
      //console.log('groupe',opts)
      return opts
    },
    simpleCalendarEvents() {
        let optss=[];
      let opts=[];
          for (var users of this.$store.state.classe.seances) {
            opts.push({startDate: users.date, classes: "event-success",title: users.titre,id: users.id})
            
            
            }
      console.log('this',opts)  
      return opts
    },
    validForm() {
        //return this.title != '' && this.startDate != '' && this.endDate != '' && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0 && !this.errors.has('event-url');
        return this.time_data!= null && this.startDate != '' && this.groupe_data != null  ;

    },
    disabledDatesTo() {
        return { to: new Date(this.startDate) }
    },
    disabledDatesFrom() {
        return { from: new Date(this.endDate) }
    },
    calendarLabels() {
        //return this.$store.state.calendar.eventLabels
        //console.log('this.$store.state.domaine.users',this.$store.state.domaine.users)
        
      let opts =[]  
            opts.push({color: "success", text:this.$store.state.classe.seances[0].titre ,value: this.$store.state.classe.seances[0].titre})
               
      return opts
    
    },
    labelColor() {
        return (label) => {
            if (label == "business") return "success"
            else if (label == "work") return "warning"
            if (label == "personal") return "danger"
            if (label == "none") return "primary"
        }
    },
    windowWidth() {
      //return this.$store.state.windowWidth
    }
  },
  methods: {
    vider(){
      this.id = null
      this.groupe_data = {label: null, value: null}
      this.startDate = null
      this.time_data = null   
    },
    addEvent() {
        const obj = { formateur_id: 1,classe_id: this.groupe_data.value, date: this.startDate, time: this.time_data }
        //obj.classes = "event-" + this.labelColor(this.labelLocal)
        console.log(obj)
        this.$store.dispatch('seance/addItem', obj)
        this.$store.dispatch("classe/fetchSeances",this.$route.params.userId)
        this.$store.dispatch("classe/fetchSeances",this.$route.params.userId)
        this.vider();
    },
    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },
    clearFields() {
        this.title = this.endDate = this.url = "";
        this.id= 0;
        this.labelLocal = "none";
    },
    promptAddNewEvent(date) {
        this.disabledFrom = false;
        this.addNewEventDialog(date);
    },
    addNewEventDialog(date) {
        this.vider();
        //this.startDate = date;
        //this.endDate = date;
        this.activePromptAddEvent = true;
    },
    openAddNewEvent(date) {
        this.disabledFrom = true;
        this.addNewEventDialog(date);
    },
    openEditEvent(event) {
      
      const e = this.$store.getters['classe/getSeanceClasse'](event.id)
      //console.log('event.id',event.id)
      /*this.$store.dispatch('seance/fetchUser',event.id)
      this.$store.dispatch('seance/fetchUser',event.id)
      const e = this.$store.state.seance.seance[0]*/
      console.log('good',e)
      this.id = e.id
      this.groupe_data = {label: e.titre+' '+'Groupe'+' '+e.numero, value: e.classe_id}
      this.startDate = e.date
      this.time_data = e.time
      //this.url = e.url
      //this.labelLocal = e.label
      this.activePromptEditEvent = true;
    },
    editEvent() {
        const obj = {id:this.id, formateur_id: 1,classe_id: this.groupe_data.value, date: this.startDate, time: this.time_data }
      //obj.classes = "event-" + this.labelColor(this.labelLocal)
      this.$store.dispatch('seance/updateRecord', obj)
      this.$store.dispatch("classe/fetchSeances",this.$route.params.userId)
      this.vider();
      
    },
    removeEvent() {
      this.$store.dispatch('seance/removeRecord', this.id)
      this.vider();
    },
    eventDragged(event, date) {
      //this.$store.dispatch('calendar/eventDragged', {event: event, date: date})
    }
  },
  created() {
    //console.log(this.$store.state.AppActiveUser.id)
    /*this.$store.registerModule('calendar', moduleCalendar)
    this.$store.dispatch("calendar/fetchEvents")
    this.$store.dispatch("calendar/fetchEventLabels")*/
    //groupe
    this.$store.registerModule('seance', moduleseance)
    this.$store.registerModule('classe', moduleclasse)
    
    this.$store.dispatch("classe/fetchSeances",this.$route.params.userId)
    console.log('this',this.$store.state) 
    console.log('this',this.$route.params.userId) 
    
    
    //console.log(this.$store.state.seance.seance)
    //console.log(this.$store.state.calendar.events)
    //console.log(this.$store.state.seance.users)
    //console.log(this.$store.state.classe.users)
  },
  /*beforeDestroy() {
    this.$store.unregisterModule('calendar')
    console.log('beforeDestroy')
  }*/
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
